<template>
  <div class="awardContainer" :style="bgStyle">
    <div class="amount">
      {{ amount | centToYuan }}<span class="unit">元</span>
    </div>
    <span class="preDesc">最高</span>
  </div>
</template>

<script>
import { centToYuan } from '../../helper';

export default {
  props: {
    awardData: {
      type: Object,
      required: true
    }
  },
  filters: {
    centToYuan
  },
  computed: {
    bgStyle() {
      return {
        background: `center / cover no-repeat url("${this.awardData.imgUrl}")`
      };
    },
    amount() {
      return this.awardData.amount;
    }
  }
};
</script>

<style lang="less" scoped>
.awardContainer {
  width: 100%;
  height: 100%;
  font-size: inherit;
  color: #fff;
  line-height: 1;
  overflow: hidden;

  .preDesc {
    padding: 2px 10px;
    background-color: #ffec95;
    color: #ff6600;
    font-size: 0.56em;
    border-radius: 24px;
  }

  .amount {
    margin-top: 45%;
    font-size: 1em;
    font-family: 'Alibaba Zhixing';

    .unit {
      font-size: 0.63em;
    }
  }
}
</style>
